import { ReactComponent as CertificateIconSVG } from '@/assets/icons/CertificateIcon.svg';
import { SVGProps } from 'react';

const CertificateIcon = (props: SVGProps<SVGSVGElement>) => <CertificateIconSVG {...props} />;

export default CertificateIcon;
